import * as cannedResponses from "@/utils/OTR/cannedResponsesOTR";
import * as cannedResponsesTempControl from "@/utils/OTR/cannedResponsesTempControl";

export default {
  namespaced: true,
  state: {
    cannedResponses: {
      // "FTL QUOTE": cannedResponses.FTL_QUOTE,
      // "PARTIAL FTL QUOTE": cannedResponses.PARTIAL_FTL_QUOTE,
      // "FTL QUOTE CANADA": cannedResponses.FTL_QUOTE_CANADA,
      "DEDICATED QUOTE": cannedResponses.DEDICATED_QUOTE,
      "DEDICATED ESPAÑOL": cannedResponses.DEDICATED_ESPAÑOL,
      "PARTIAL QUOTE": cannedResponses.PARTIAL_QUOTE,
      "PARTIAL ESPAÑOL": cannedResponses.PARTIAL_ESPAÑOL,
      "QUOTE CANADA": cannedResponses.QUOTE_CANADA,
      "CANADA ESPAÑOL": cannedResponses.CANADA_ESPAÑOL,
      "CALIFORNIA QUOTE": cannedResponses.CALIFORNIA_QUOTE,
      "CALIFORNIA ESPAÑOL": cannedResponses.CALIFORNIA_ESPAÑOL,
      "CAR CARRIER": cannedResponses.CAR_CARRIER,
      // "HEAVY HAUL QUOTE": cannedResponses.HEAVY_HAUL_QUOTE,
      // "HEAVY HAUL PARTIAL QUOTE": cannedResponses.HEAVY_HAUL_PARTIAL_QUOTE,
      "DRAYAGE QUOTE": cannedResponses.DRAYAGE_QUOTE,
      "SS - YRC": cannedResponses.SS_YRC,
      "SS - EXPEDITED": cannedResponses.SS_EXPEDITED,
      "SS - EXP - IBC": cannedResponses.SS_EXP_IBC,
      /* TEMP CONTROL CANNED */
      "DRAYAGE QUOTE GENERAL": cannedResponsesTempControl.DRAYAGE_QUOTE_GENERAL,
      "DRAYAGE QUOTE NY NJ": cannedResponsesTempControl.DRAYAGE_QUOTE_NY
    },
    cannedResponsesTempControl: {
      "REEFER LTL QUOTE FEE KOOLPAK":
        cannedResponsesTempControl.REEFER_LTL_QUOTE_FEE_KOOLPAK,
      "REEFER LTL QUOTE ROADTEX":
        cannedResponsesTempControl.REEFER_LTL_QUOTE_ROADTEX,
      "REEFER LTL QUOTE CANNON":
        cannedResponsesTempControl.REEFER_LTL_QUOTE_CANNON,
      "REEFER LTL QUOTE ESPAÑOL":
        cannedResponsesTempControl.REEFER_LTL_QUOTE_ESPAÑOL,
      "FTL QUOTE": cannedResponsesTempControl.FTL_QUOTE,
      "FTL QUOTE ESPAÑOL": cannedResponsesTempControl.FTL_QUOTE_ESPAÑOL,
      "FTL QUOTE CANADA": cannedResponsesTempControl.FTL_QUOTE_CANADA,
      "FTL QUOTE CANADA ESPAÑOL":
        cannedResponsesTempControl.FTL_QUOTE_CANADA_ESPAÑOL,
      "FTL CALIFORNIA QUOTE": cannedResponsesTempControl.FTL_CALIFORNIA_QUOTE,
      "FTL CALIFORNIA ESPAÑOL":
        cannedResponsesTempControl.FTL_CALIFORNIA_ESPAÑOL,
      "FTL QUOTE SPRINTER":
        cannedResponsesTempControl.FTL_SPRINTER_VAN_STRAIGHT_TRUCK,
      "FTL QUOTE SPRINTER ESPAÑOL":
        cannedResponsesTempControl.FTL_SPRINTER_VAN_STRAIGHT_TRUCK_ESPAÑOL,
      "CAR CARRIER": cannedResponsesTempControl.CAR_CARRIER
    },
    signature: cannedResponses.SIGNATURE,
    rate: []
  },
  getters: {
    showCannedResponses(state) {
      return state.cannedResponses;
    },
    showCannedResponsesTempControl(state) {
      return state.cannedResponsesTempControl;
    },
    showSignature(state) {
      return state.signature;
    },
    showRate(state) {
      return state.rate;
    }
  },
  mutations: {
    setRate(state, rate) {
      state.rate[rate.tripNumber] = rate;
    }
  }
};
